import GenericErrorModule from './GenericError.module';

export default GenericErrorModule;
